'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _card_component = require('./global_components/card_component.js');

var _card_component2 = _interopRequireDefault(_card_component);

var _number_utility = require('../../../packages/common-utilities/src/number_utility.js');

var _number_utility2 = _interopRequireDefault(_number_utility);

var _string_utility = require('../../../packages/common-utilities/src/string_utility.js');

var _string_utility2 = _interopRequireDefault(_string_utility);

var _currency_utility = require('common-utilities/src/currency_utility');

var _currency_utility2 = _interopRequireDefault(_currency_utility);

var _ramda = require('ramda');

var _reactIntl = require('react-intl');

var _collection_utility = require('../../../packages/common-utilities/src/collection_utility');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FundCharges = function (_React$Component) {
  _inherits(FundCharges, _React$Component);

  function FundCharges() {
    _classCallCheck(this, FundCharges);

    return _possibleConstructorReturn(this, (FundCharges.__proto__ || Object.getPrototypeOf(FundCharges)).apply(this, arguments));
  }

  _createClass(FundCharges, [{
    key: 'renderHeaderRow',
    value: function renderHeaderRow(rowHeader, value, dataTestId) {
      return React.createElement(
        'div',
        { className: 'row margin-all-0 padding-vertical-5' },
        React.createElement(
          'div',
          { className: 'col-md-12 col-lg-12 col-xlg-12 padding-left-0 padding-right-0' },
          React.createElement(
            'div',
            { 'data-testid': dataTestId, className: 'text-left col-xs-7 col-md-7 col-lg-7 col-xlg-7 font-regular tag' },
            rowHeader
          ),
          React.createElement(
            'div',
            { 'data-testid': dataTestId + '-value', className: 'text-right col-xs-5 col-md-5 col-lg-5 col-xlg-5 font-regular tag' },
            value
          )
        )
      );
    }
  }, {
    key: 'generateBuySellSpread',
    value: function generateBuySellSpread() {
      var returnResult = '';
      if (this.props.fees.buySpread === 0 || (0, _ramda.isNil)(this.props.fees.buySpread)) {
        returnResult = '0%/';
      } else {
        returnResult = this.props.fees.buySpread + '%/';
      }

      if (this.props.fees.sellSpread === 0 || (0, _ramda.isNil)(this.props.fees.sellSpread)) {
        returnResult += '0%';
      } else {
        returnResult += this.props.fees.sellSpread + '%';
      }

      return returnResult;
    }
  }, {
    key: 'sumManagementFeesAndCosts',
    value: function sumManagementFeesAndCosts() {
      var validValues = [this.props.fees.managementFee, this.props.fees.expenseRecoveries, this.props.fees.otherIndirectCosts].filter(function (n) {
        return !isNaN(n);
      }).filter(function (n) {
        return n !== null;
      });

      var fallbackValue = 'Nil';
      if (validValues.length === 0) {
        return fallbackValue;
      }
      return _number_utility2.default.formatToPercentWithSuppliedDecimalPointCount((0, _ramda.sum)(validValues), 2, fallbackValue);
    }
  }, {
    key: 'render',
    value: function render() {
      return React.createElement(
        _card_component2.default,
        {
          dataTest: 'fund-charges',
          className: 'print-full-width',
          headerTitle: React.createElement(_reactIntl.FormattedMessage, { id: 'pdp-overview-fund-charges-label',
            defaultMessage: 'Charges' }),
          headerTitleId: "fund-charges-header",
          headerTitleLabel: "",
          headerLabel: "",
          displayStyle: 'width-percent-100',
          disclosureText: (0, _ramda.pathOr)(null, ["disclosures", "pdpCardCharges"], this.props),
          breakpoint: this.props.breakpoint
        },
        React.createElement(
          'div',
          { 'data-testid': 'fund-charges' },
          this.renderHeaderRow(_string_utility2.default.renderFormattedLabel("Management fees and costs", "pdp-overview-fund-charges-management-fee-and-costs"), this.sumManagementFeesAndCosts(), 'fund-charges-management-fee-and-costs'),
          !_collection_utility.CollectionUtility.includes(this.props.visibleData.visibleDataPoints, 'FUND_CHARGES_NO_MIN_INVESTMENT') && !(0, _ramda.isNil)(this.props.investmentLimitAmount) && this.renderHeaderRow(_string_utility2.default.renderFormattedLabel("Minimum investment", "pdp-overview-fund-charges-minimum-investment"), _currency_utility2.default.getCurrencyMapping(this.props.currencyCode) + _number_utility2.default.convertToNumberWithCommas(this.props.investmentLimitAmount), 'fund-charges-minimum-investment'),
          _collection_utility.CollectionUtility.includes(this.props.visibleData.visibleDataPoints, 'FUND_CHARGES_BUY_SELL_SPREAD') && (!(0, _ramda.isNil)(this.props.fees.buySpread) || !(0, _ramda.isNil)(this.props.fees.sellSpread)) && this.renderHeaderRow(_string_utility2.default.renderFormattedLabel("Buy/sell spread", "pdp-overview-fund-charges-buy-sell-spread"), this.generateBuySellSpread(), 'fund-charges-buy-sell-spread')
        )
      );
    }
  }]);

  return FundCharges;
}(React.Component);

exports.default = FundCharges;